import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import './index.css'
import { reportWebVitals } from './lib/performance'
import { appQueryClient } from './lib/queryClient'

const queryClient = appQueryClient

const router = createRouter({ 
  routeTree, 
  context: { queryClient },
  defaultPendingComponent: () => (
    <div className="min-h-screen bg-lm-bg flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-lm-primary border-t-transparent rounded-full animate-spin" />
    </div>
  ),
  defaultErrorComponent: ({ error }) => (
    <div className="min-h-screen bg-lm-bg flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-xl font-bold text-lm-on-surface mb-2">Something went wrong</h1>
        <p className="text-lm-on-surface-variant text-sm">{error.message}</p>
      </div>
    </div>
  )
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Report web vitals for performance monitoring
reportWebVitals()

const rootElement = document.getElementById('root')!
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={
        <div className="min-h-screen bg-lm-bg flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-lm-primary border-t-transparent rounded-full animate-spin" />
        </div>
      }>
        <RouterProvider router={router} />
      </Suspense>
    </QueryClientProvider>
  </React.StrictMode>
)
